/* esm.sh - iobuffer@6.0.1 */
export * from "/*iobuffer@6.0.1/esnext/iobuffer.mjs";
